/* Condensed layout for  SDK Usage */
import { FC, useState } from 'react';
import { useDispatch } from 'react-redux';

import { isMatchAuth } from 'cashout/helpers/utils';
import classnames from 'classnames';

import EventNotification from 'common/services/event-notification';
import storageService from 'common/services/storage-service';

import { useAppSelector, useCallOnInit, useParentPostMessage } from 'common/helpers/hooks';
import { getQueryParam } from 'common/helpers/url';
import { getWhiteLabel, setIsSdk, setMobileSdk } from 'common/store/global';

import CloseSdkAction from '../close-sdk-action/close-sdk-action';
import useCondensedStyles from './styles';

const CondensedWrapper: FC = ({ children }) => {
  const classes = useCondensedStyles();
  const dispatch = useDispatch();
  const isAuth = isMatchAuth();
  const eventNotification = new EventNotification('*', window);

  const [showCondensedView, setShowCondensedView] = useState(false);

  const isSdk = !!getQueryParam('condensed');
  const isMobileSdk = getQueryParam('mobile') === 'true';
  const isIframeEmbedded = window.self !== window.top;
  const isWhiteLabel = useAppSelector(getWhiteLabel);

  const handleSdkSession = () => {
    storageService.setSession('AP_SDK_SESSION', 'true');
  };

  const onCloseSDK = () => {
    eventNotification.notify('close', {});

    //Legacy close message
    useParentPostMessage(parent, { action: 'close', message: 'close' }, true, undefined);
  };

  useCallOnInit(() => {
    dispatch(setIsSdk(isSdk));
    dispatch(setMobileSdk(isMobileSdk));
    // initial checking for SDK
    if (isSdk && isIframeEmbedded) {
      handleSdkSession();
      setShowCondensedView(true);
      document.body.style.backgroundColor = 'transparent';
      return;
    }
  });

  if (showCondensedView) {
    return (
      <>
        {!isAuth && <CloseSdkAction />}
        <div
          id="condensedSDKView"
          className={classnames(classes.condensedSDKView, {
            auth: isAuth,
            whiteLabel: isWhiteLabel,
          })}
        >
          {isAuth && <CloseSdkAction className="auth" />}
          {children}
        </div>
        <div className={classes.mirrorBackdrop} onClick={onCloseSDK}></div>
      </>
    );
  }

  return <>{children}</>;
};

export default CondensedWrapper;
